<div class="nav-rail">
  <ng-content></ng-content>
</div>
